<ai-text-input
    [formControl]="formControl"
    [actions]="actions()"
    [placeholder]="placeholder()"
    (keyup)="onKeyUp($event)"
    (actionPerformed)="onActionPerformed($event)"
/>
